import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("admin_token");
export const setToken = (t) => localStorage.setItem("admin_token", t);
export const clearToken = () => localStorage.removeItem("admin_token");

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const assetUrl = (p) => (p && p.startsWith("/") ? `${BACKEND_URL}${p}` : p);

export const api = {
  login: (password) => axios.post(`${API}/auth/login`, { password }),
  verify: () => axios.get(`${API}/auth/verify`, { headers: authHeaders() }),
  listWorlds: () => axios.get(`${API}/worlds`),
  getWorld: (id) => axios.get(`${API}/worlds/${id}`),
  createWorld: (body) => axios.post(`${API}/worlds`, body, { headers: authHeaders() }),
  updateWorld: (id, body) => axios.put(`${API}/worlds/${id}`, body, { headers: authHeaders() }),
  deleteWorld: (id) => axios.delete(`${API}/worlds/${id}`, { headers: authHeaders() }),
  previewUrl: (id) => `${API}/worlds/${id}/preview`,
  zipUrl: (id) => `${API}/worlds/${id}/generate`,
};
